import React from 'react';
import PropTypes from 'prop-types';
import scrollToElement from 'scroll-to-element';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.scss';

const ScrollingValuePropSelector = ({
  scrollTo,
  title,
  icon
}) => (
  <div className={styles.valuePropSelector} onClick={() => scrollToElement(scrollTo)} >
    <FontAwesomeIcon className="mr-3" size="lg" fixedWidth icon={icon} />
    <span>{title}</span>
    <FontAwesomeIcon size="lg" fixedWidth icon="chevron-right" />
  </div>
);

ScrollingValuePropSelector.propTypes = {
  scrollTo: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.string
};

export default ScrollingValuePropSelector;
